import { Row, Col, Button } from 'antd'
import styled from 'styled-components'

export const Header = styled(Row).attrs({
  type: 'flex',
  justify: 'space-between',
  align: 'middle'
}) `
  background: #171C20;
  color: white;
  text-align: center;
  img {
    vertical-align: middle;
    margin: 8px;
    &.thairunLogo {
      width: 40px;
    }
  }

  .title {
    font-size: 18px;
    margin: 8px;
    vertical-align: middle;
    font-weight: 200;
    color: white;
  }
`

export const HeaderCol = styled(Col).attrs({
  sm: 8,
  xs: 24
})`
  margin: 8px auto;
`

export const Notice = styled.div`
  display: inline-block;
  font-size: 18px;
  font-weight: lighter;
  background-color: #244596;
  color: white;
  margin: 34px;
  padding: 18px 26px;
  img {
    vertical-align: middle
  }
  border-radius: 4px;
`

export const Results = styled.div`
  .loading {
    margin-top: 30vh;
  }
  .photos {
    margin-bottom: 300px;
    .sectionHeader {
      padding: 24px 8px 8px;
    }
    .galleryContainer {
      display: block;
      min-height: 1px;
      width: 100%;
      overflow: auto;
    }
  }
`

export const SelectImgButton = styled(Button) `
  margin: 8px;
  height: initial;
  padding: 8px;
  img {
    max-height: 200px;
    max-width: 200px;
  }
`

export const Footer = styled(Row).attrs({
  type: 'flex',
  justify: 'space-between',
  align: 'bottom'
})`
  position: fixed;
  bottom: 0px;
  width: 100%;
  font-size: 14px;
  pointer-events: none;
  img {
    vertical-align: bottom;
  }
  .refImageCol {
    text-align: right;
  }
  .sponsorCol {
    .sponsorText {
      pointer-events: all;
      color: black;
      //width: 250px;
      display: inline-block;
      padding: 8px;
      margin: 4px;
      background: rgba(255, 255, 255, 0.8);
      border-radius: 8px;
      font-size: 12px;
      img {
        height: 48px;
        vertical-align: middle;
      }
    }
  }
`

export const Body = styled.div`
  text-align: center;
  margin-bottom: 350px;
`


// WEBPACK FOOTER //
// ./src/styles/index.js